import React from "react";
import { TextField, Button, Select, MenuItem, Checkbox } from "@mui/material";
const FamilyRelationshipsTable = ({ relationships, setRelationships }) => {
  const relationshipTypes = [
    "Spouse/Partner",
    "Mother",
    "Father",
    "Sibling",
    "Other",
  ];

  const handleRelationshipChange = (index, field, value) => {
    setRelationships((prev) => {
      const updated = [...prev];
      updated[index][field] = value;
      return updated;
    });
  };

  const addRelationshipRow = () => {
    setRelationships((prev) => [
      ...prev,
      {
        type: "",
        name: "",
        deceased: false,
        regularContact: false,
        infrequentNoContact: false,
        supportsRecovery: false,
        doesNotUnderstandRecovery: false,
        usedSubstancesWith: false,
        conflictInRelationship: false,
      },
    ]);
  };

  const removeRelationshipRow = (index) => {
    setRelationships((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <div style={{ marginBottom: "10px", paddingTop: "20px" }}>
      <div
        style={{
          overflowX: "auto",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={styles.header}>Type</th>
              <th style={styles.header}>Name (if sibling or other)</th>
              <th style={styles.header}>Deceased</th>
              <th style={styles.header}>Regular contact</th>
              <th style={styles.header}>Infrequent/No Contact</th>
              <th style={styles.header}>Supports recovery</th>
              <th style={styles.header}>Does not understand recovery</th>
              <th style={styles.header}>Used Substances with</th>
              <th style={styles.header}>Conflict in relationship</th>
              <th style={styles.header}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {relationships.map((relation, index) => (
              <tr key={index}>
                <td style={styles.cell}>
                  <Select
                    value={relation.type}
                    onChange={(e) =>
                      handleRelationshipChange(index, "type", e.target.value)
                    }
                    fullWidth
                  >
                    {relationshipTypes.map((type) => (
                      <MenuItem key={type} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </Select>
                </td>
                <td style={styles.cell}>
                  {(relation.type === "Sibling" ||
                    relation.type === "Other") && (
                    <TextField
                      value={relation.name}
                      onChange={(e) =>
                        handleRelationshipChange(index, "name", e.target.value)
                      }
                      fullWidth
                      placeholder="Name"
                    />
                  )}
                </td>
                <td style={styles.cell}>
                  <Checkbox
                    checked={relation.deceased}
                    onChange={(e) =>
                      handleRelationshipChange(
                        index,
                        "deceased",
                        e.target.checked
                      )
                    }
                  />
                </td>
                <td style={styles.cell}>
                  <Checkbox
                    checked={relation.regularContact}
                    onChange={(e) =>
                      handleRelationshipChange(
                        index,
                        "regularContact",
                        e.target.checked
                      )
                    }
                  />
                </td>
                <td style={styles.cell}>
                  <Checkbox
                    checked={relation.infrequentNoContact}
                    onChange={(e) =>
                      handleRelationshipChange(
                        index,
                        "infrequentNoContact",
                        e.target.checked
                      )
                    }
                  />
                </td>
                <td style={styles.cell}>
                  <Checkbox
                    checked={relation.supportsRecovery}
                    onChange={(e) =>
                      handleRelationshipChange(
                        index,
                        "supportsRecovery",
                        e.target.checked
                      )
                    }
                  />
                </td>
                <td style={styles.cell}>
                  <Checkbox
                    checked={relation.doesNotUnderstandRecovery}
                    onChange={(e) =>
                      handleRelationshipChange(
                        index,
                        "doesNotUnderstandRecovery",
                        e.target.checked
                      )
                    }
                  />
                </td>
                <td style={styles.cell}>
                  <Checkbox
                    checked={relation.usedSubstancesWith}
                    onChange={(e) =>
                      handleRelationshipChange(
                        index,
                        "usedSubstancesWith",
                        e.target.checked
                      )
                    }
                  />
                </td>
                <td style={styles.cell}>
                  <Checkbox
                    checked={relation.conflictInRelationship}
                    onChange={(e) =>
                      handleRelationshipChange(
                        index,
                        "conflictInRelationship",
                        e.target.checked
                      )
                    }
                  />
                </td>
                <td style={styles.cell}>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => removeRelationshipRow(index)}
                  >
                    Remove
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div style={{ marginTop: "10px" }}>
          <Button variant="outlined" onClick={addRelationshipRow}>
            Add Relationship
          </Button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  header: {
    border: "1px solid lightgray",
    padding: "10px",
    textAlign: "center",
    backgroundColor: "#f0f0f0",
  },
  cell: {
    border: "1px solid lightgray",
    padding: "10px",
    textAlign: "center",
  },
};

export default FamilyRelationshipsTable;
